import IconLogoBlack from '@/assets/icons/icon-logo-black.svg'
import IconLogoWhite from '@/assets/icons/icon-logo-white.svg'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import {
  sendCustomAppAction,
  useDesktopApp,
} from '@/modules/desktop/DesktopAppProvider'
import { useIsDarkTheme } from '@/utils/useTheme.tsx'

export const AboutCreatorHero = () => {
  const { isApp, appVersion, lastPublishedAppVersion } = useDesktopApp()
  const isDarkMode = useIsDarkTheme()

  return (
    <div className="bg-background flex h-[calc(100vh-72px)] flex-col items-center justify-center">
      <div className="bg-card w-full max-w-[616px] rounded-2xl px-6 py-10 shadow-xl">
        <div className="space-y-4 text-center">
          <div className="mx-auto h-[84px] w-[84px]">
            {isDarkMode ? <IconLogoWhite /> : <IconLogoBlack />}
          </div>
          {isApp && (
            <>
              <div className="mb-4 text-sm font-medium leading-6">
                <span className="text-secondary-300">
                  You have the following version of the application installed:
                </span>
                <span className="text-secondary-500"> v{appVersion}</span>
              </div>
              {lastPublishedAppVersion &&
                lastPublishedAppVersion !== 'null' &&
                lastPublishedAppVersion !== appVersion && (
                  <Button
                    className="mx-auto"
                    onClick={() =>
                      sendCustomAppAction('update-to-latest-version')
                    }
                  >
                    Update to: v{lastPublishedAppVersion}
                  </Button>
                )}
            </>
          )}
        </div>
        <Separator className="my-6" />
        <div className="space-y-4">
          <div className="text-xl font-semibold">
            Join the CreatorHero Family
          </div>
          <Action
            label="Our official Telegram Group"
            buttonLabel="Join the Group"
            href="https://t.me/+7l_E_MNbpeE5NTgx"
            testId="about-us-telegram-group"
          />
          <Action
            label="Stay up to date with CreatorHero"
            buttonLabel="Join the Channel"
            href="http://t.me/creatorhero"
            testId="about-us-telegram-chanel"
          />
        </div>
      </div>
    </div>
  )
}

const Action = ({
  label,
  buttonLabel,
  href,
  testId,
}: {
  label: string
  buttonLabel: string
  href: string
  testId?: string
}) => {
  return (
    <div className="flex w-full items-center justify-between">
      <div className="text-base">{label}</div>
      <a
        href={href}
        data-testid={`${testId}-link`}
        target="_blank"
        rel="noreferrer"
      >
        <Button
          testId={testId}
          variant="outline"
          className="w-[150px]"
        >
          {buttonLabel}
        </Button>
      </a>
    </div>
  )
}
